import {AfterViewInit, Component, ElementRef, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Subscription} from 'rxjs';
import {SignDocumentService} from 'src/app/core/services/sign-document.service';
import {NotificationService} from 'src/app/core/services/notification.service';
import {ToastrService} from 'ngx-toastr';
import {Message} from 'src/app/core/class/message';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import {first, map} from 'rxjs/operators';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {ErrorCode} from '../../../../../../core/constants/error-code';
import {AnonymousSignService} from 'src/app/core/services/anonymous-sign.service';
import {Common} from '../../../../../../core/constants/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-confirm-sign-otp-with-image',
  templateUrl: './confirm-sign-otp-with-image.component.html',
  styleUrls: ['./confirm-sign-otp-with-image.component.scss']
})
export class ConfirmSignOtpWithImageComponent implements OnInit, AfterViewInit {

  sign = {
    contractId: '',
    otp: '',
    transactionId: '',
    anonymousOtp: false
  };

  success = false;
  countDownOTP = 0;
  isAcceptRequest = true;

  // Refer to form in view
  @ViewChild('f', {static: false}) ngForm: NgForm;
  @ViewChild("inputOtp", {static: false}) inputElement: ElementRef;

  // Whether the form change or not
  isFormChanging = false;
  isValid = true;
  show = true;
  openSigningDialog = false;
  otpPattern = Common.OTP_PATTERN;
  // Subscribe to form changing
  formChangesSubscription: Subscription;
  subscriptions: Subscription = new Subscription();
  hashLink: string = null;
  constructor(
    private signDocumentService: SignDocumentService,
    private signAnonymusService: AnonymousSignService,
    private dialogRef: MatDialogRef<ConfirmSignOtpWithImageComponent>,
    private notificationService: NotificationService,
    private toastr: ToastrService,
    private dialog: MatDialog,
    private message: Message,
    private router: Router,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // disable chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
    this.subscriptions.add(
      this.signDocumentService.openSigningDialog.asObservable().subscribe(rs => {
        this.openSigningDialog = rs
      })
    );
  }

  /**
   * Init component
   */
  ngOnInit() {
    this.sign.contractId = this.data.documentId;
    this.sign.transactionId = this.data.transaction;
    this.hashLink = this.data.hashLink;
    this.notificationService.subscribeErrorService();
  }

  /**
   * Destroy component
   */
  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
    if(!this.openSigningDialog){
      clearInterval(this.data.signingInteval);
      if(this.data.dataCancel.tenantId){
        this.signAnonymusService.signCancel(this.data.dataCancel,this.hashLink).subscribe(rs => {
          this.checkDisplayMessageError(rs.code);
        });
      }else{
        this.signDocumentService.signCancel(this.data.dataCancel).subscribe(res => {
        });
      }
    }
  }

  /**
   * Confirm sign OTP
   */
  async confirmSignOtp() {
    await this.data.function(this.sign, this.dialogRef, this.focusInput.bind(this));
  }

  countDown() {
    this.countDownOTP = 60;
    let interval = setInterval(() => {
      if (this.countDownOTP > 0) {
        this.countDownOTP -= 1;
      }

      if (this.countDownOTP <= 0) {
        clearInterval(interval);
      }

    }, 1000)
  }

  /**
   * Send code OTP again
   */
  onSendCodeOTPAgain() {
    // if (!this.isAcceptRequest) {
    //   return
    // }
    // this.isAcceptRequest = false;
    // this.countDown();

    if (!this.data.anonymousOtp) {
      this.signDocumentService.generateTransaction(this.data.documentId, this.data.selectedPhone, this.data.request).subscribe(rs => {
        this.checkDisplayMessageError(rs.code);
        if (!rs.success) {
          if (rs.code === ErrorCode.OutOfMoneyOtp) {
            this.toastr.error(this.message.getMessage('messages.otp_out_of_money'));
          } else {
            this.toastr.error(rs.message);
          }
        } else {
          this.sign.transactionId = rs.data;
          this.toastr.success(this.message.getMessage('messages.send_code_otp_again'));
        }

        // this.isAcceptRequest = true;
      });
    } else {
      this.signAnonymusService.generateTransaction(this.data.hashKey, this.data.selectedPhone, this.data.tenantId, this.data.request,this.hashLink).subscribe(rs => {
        this.checkDisplayMessageError(rs.code);
        if (!rs.success) {
          if (rs.code === ErrorCode.OutOfMoneyOtp) {
            this.toastr.error(this.message.getMessage('messages.otp_out_of_money'));
          } else {
            // if(!this.hashLink) {
              this.toastr.error(rs.message);
            // }
          }
        } else {
          this.sign.transactionId = rs.data;
          this.toastr.success(this.message.getMessage('messages.send_code_otp_again'));
        }
        // this.isAcceptRequest = true;
      });
    }
  }

  /**
   * Close dialog
   */
  onNoClick() {
    if (this.data.supportEkyc) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data_and_back_to_pre_page')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.show = false;
          dialogRe.close();
          this.dialogRef.close();
        }
      })
    } else {
      if (this.isFormChanging) {
        const dialogRe = this.dialog.open(WarningComponent, {
          width: '350px',
          data: this.message.getMessage('messages.confirm_change_data')
        });
        dialogRe.afterClosed().subscribe(rs => {
          if (rs) {
            this.show = false;
            this.dialogRef.close();
          }
          dialogRe.close();
        });
      } else {
        this.dialogRef.close();
      }
    }
  }

  /**
   * Confirm before navigation
   */
  canDeactivate() {
    const tenantId = localStorage.getItem('tenantId');
    if ((this.ngForm.dirty && this.show && tenantId != null)
      || (this.show && tenantId != null)) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: this.message.getMessage('messages.confirm_change_data')
      });
      return dialogRe.afterClosed().pipe(map(result => {
        if (result) {
          return true;
        } else {
          return false;
        }
      }), first());
    } else {
      return true;
    }
  }

  focusInput() {
    if (this.inputElement.nativeElement) {
      this.inputElement.nativeElement.focus();
    }
  }

  /**
   * Init after view comp
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.focusInput();
    }, 300);
  }

  focusOut() {
    this.sign.otp = this.sign.otp ? this.sign.otp.trim() : '';
    if (this.sign.otp.length !== 4) {
      this.isValid = false
    }
  }

  focusIn() {
    this.sign.otp = this.sign.otp ? this.sign.otp.trim() : '';
    if (this.sign.otp.length === 4) {
      this.isValid = true
    }
  }
  checkDisplayMessageError(code) {
    if (code && code === ErrorCode.NoAccessToContracts) {
      //this.router.navigate([`/error`]);
      window.location.href = 'error';
      this.dialogRef.close();
    }
    else if (code && code === ErrorCode.ContractExpireTime) {
      //this.router.navigate([`/expire`]);
      window.location.href = 'expire';
      this.dialogRef.close();
    }
  }

}
